<template>
  <div class="mt-6 container-fluid">
    <div id="profile-header" class="card">
      <ProfileHeader />
    </div>
    
    <div id="personal-details" class="card mt-4">
        <PersonalDetails />
    </div>

    <div id="subscription-limits" class="card mt-4">
      <SubscriptionLimits />
    </div>

    <!-- <div id="update-password" class="card mt-4">
      <UpdatePassword />
    </div> -->

    <div id="feedback" class="card mt-4">
        <FeedbackForm />
    </div>
  </div>
</template>

<script>
import ProfileHeader from "@/components/features/profile/ProfileHeader.vue";
import PersonalDetails from "@/components/features/profile/PersonalDetails.vue";
import SubscriptionLimits from "@/components/features/profile/SubscriptionLimits.vue";
// import UpdatePassword from "@/components/features/encryption/UpdatePassword.vue";
import FeedbackForm from "@/components/features/feedback/FeedbackForm.vue";

export default {
  name: "Profile",
  components: {
    ProfileHeader,
    PersonalDetails,
    SubscriptionLimits,
    // UpdatePassword,
    FeedbackForm
  }
};
</script>